import * as Validator from './validator';

export const FormInputError = ({field}) => {
    if (field.required && !field.value) {
        switch (field.name) {
        case 'name':
            return `お名前を入力してください`;
        
        case 'email':
            return `Eメールを入力してください`;

        default:
            return `${field.name}を入力してください`;
        }
    }

    if (field.type === 'email' && !Validator.isValidEmail(field.value)) {
        return `有効なEメールアドレスではありません`;
    }
    return null;
};

export const ValidateInputForm = ({fields}) => {
    const errors = {};
    fields.forEach((field) => {
        const name = field.name;
        const fieldError = FormInputError({field});
        errors[name] = fieldError;
    });
    return errors;
};